import { Box } from "@mui/material";
import Script from "next/script";
import { Container } from "src/components-mui/layout/container";

export interface IWidgetModule {
    script?: string;
    widgetBody: string;
}

export const WidgetModule = ({ script, widgetBody }: IWidgetModule) => {
    return (
        <Container>
            {script && script.trim().length > 0 && <Script src={script} strategy="lazyOnload" />}
            <Box dangerouslySetInnerHTML={{ __html: widgetBody }} />
        </Container>
    );
};
